import { Node } from 'tiptap'

export default class DataTagNode extends Node {

  get name() {
    return 'datatag'
  }

  get schema() {
    return {
      // here you have to specify all values that can be stored in this node
      attrs: {
        uuid: '',
        value: '',
        title: '',
        blockId: '',
        path: '',
      },
      group: 'inline',
      inline: true,
      selectable: false,
      atom: true,
      // parseDOM and toDOM is still required to make copy and paste work
      parseDOM: [{
        tag: 'span',
        getAttrs: dom => ({
          uuid: dom.getAttribute('data-uuid'),
          value: dom.getAttribute('data-value'),
          title: dom.getAttribute('data-title'),
          blockId: dom.getAttribute('data-block-id'),
          path: dom.getAttribute('data-path'),
        }),
      }],
      toDOM: node => [
        'span', 
        {
          'data-uuid': node.attrs.uuid,
          'data-value': node.attrs.value,
          'data-title': node.attrs.title,
          'title': node.attrs.title,
          'data-block-id': node.attrs.blockId,
          'data-path': node.attrs.path,
        },
        `${node.attrs.value}`
      ],
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        uuid: {
          get() {
            return this.node.attrs.uuid
          },
          set(uuid) {
            this.updateAttrs({
              uuid,
            })
          },
        },
        value: {
          get() {
            return this.node.attrs.value
          },
          set(value) {
            this.updateAttrs({
              value,
            })
          },
        },
        title: {
          get() {
            return this.node.attrs.title
          },
          set(title) {
            this.updateAttrs({
              title,
            })
          },
        },
        blockId: {
          get() {
            return this.node.attrs.blockId
          },
          set(blockId) {
            this.updateAttrs({
              blockId,
            })
          },
        },
        path: {
          get() {
            return this.node.attrs.path
          },
          set(path) {
            this.updateAttrs({
              path,
            })
          },
        },
      },
      template: `
        <span class="datatag clickable" :title="title" :data-title="title" :data-uuid="uuid" :data-value="value" :data-block-id="blockId" :data-path="path">{{title}}</span>
      `,
    }
  }

}